import {toAbsoluteUrl} from "./origin";

export function getAbsoluteSitemapUrl(): string {
    return toAbsoluteUrl(`/sitemap`);
}
